webpackJsonp([42284298787330],{

/***/ 605:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"edges":[{"node":{"baseTitle":"InsideOut","top_sticky":{"enabled":true,"color":"000000","text_color":"ffffff","content":"<p><a href=\"https://insideoutinstitute.org.au/medicare\">Medicare Info Here</a></p>\n"},"header_links":[{"link_text":"About","link_url":"","submenu":[{"link_text":"About Eating Disorders","link_url":"/about-eating-disorders"},{"link_text":"About InsideOut","link_url":"/about-us"}]},{"link_text":"News & Events","link_url":"","submenu":[{"link_text":"News","link_url":"/news"},{"link_text":"Events","link_url":"/events"},{"link_text":"Blog & Podcast","link_url":"/blog-and-podcast"},{"link_text":"Media","link_url":"/media-office"}]},{"link_text":"Training, Policy & Research","link_url":"","submenu":[{"link_text":"eLearning","link_url":"/e-learning"},{"link_text":"Other Training","link_url":"/events"},{"link_text":"Policy & Service Development","link_url":"/policy-and-service-development"},{"link_text":"Research","link_url":"/research"},{"link_text":"Projects","link_url":"/projects"}]},{"link_text":"Get Support","link_url":"","submenu":[{"link_text":"Find Treatment","link_url":"/treatment-services"},{"link_text":"Find Resources","link_url":"/resource-library"},{"link_text":"Get Assessed","link_url":"/for-myself"},{"link_text":"Find Support Organisations","link_url":"/support-organisations"},{"link_text":"Medicare","link_url":"/medicare"}]},{"link_text":"Get Involved","link_url":"/get-involved","submenu":null}],"footer_links":[{"section_name":"Get Support","links":[{"link_text":"Treatment Services Database","link_url":"/treatment-services"},{"link_text":"eLearnings","link_url":"/e-learning"},{"link_text":"Resource Library","link_url":"/resource-library"},{"link_text":"Support Organisations","link_url":"/support-organisations"}]},{"section_name":"Get Involved","links":[{"link_text":"Donate","link_url":"/get-involved/make-a-donation"},{"link_text":"Fundraise","link_url":"/get-involved/hold-a-fundraiser"},{"link_text":"Employment","link_url":"/employment"},{"link_text":"Volunteering","link_url":"/get-involved/volunteer"},{"link_text":"Contact Us","link_url":"/contact-us"}]},{"section_name":"Services and Research","links":[{"link_text":"Policy & Service Development","link_url":"/policy-and-service-development"},{"link_text":"Research","link_url":"/research"}]},{"section_name":"News","links":[{"link_text":"News & Events","link_url":"/news-and-events"},{"link_text":"Blog & Podcast","link_url":"/blog-and-podcast"},{"link_text":"Media","link_url":"/media-office"}]}],"mobile_links":[{"links":[{"link_text":"About Eating Disorders","link_url":"/about-eating-disorders"},{"link_text":"eLearning","link_url":"/e-learning"},{"link_text":"Find Treatment","link_url":"/treatment-services"}]},{"links":[{"link_text":"Who are we?","link_url":"/about-us"},{"link_text":"Get Involved","link_url":"/get-involved"},{"link_text":"Donate","link_url":"/get-involved/make-a-donation"}]},{"links":[{"link_text":"Resource Library","link_url":"/resource-library"},{"link_text":"Treatment Services Database","link_url":"/treatment-services"},{"link_text":"eLearning","link_url":"/e-learning"}]}]}}]}},"layoutContext":{}}

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(1033);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _layoutMain = __webpack_require__(605);
	
	var _layoutMain2 = _interopRequireDefault(_layoutMain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_main2.default, _extends({}, props, _layoutMain2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Footer = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(9);
	
	var _socialIcons = __webpack_require__(172);
	
	var _logo = __webpack_require__(431);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _hamburgerIcon = __webpack_require__(868);
	
	var _hamburgerIcon2 = _interopRequireDefault(_hamburgerIcon);
	
	var _closeIcon = __webpack_require__(866);
	
	var _closeIcon2 = _interopRequireDefault(_closeIcon);
	
	var _styles = __webpack_require__(985);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterComponent = function (_React$PureComponent) {
		_inherits(FooterComponent, _React$PureComponent);
	
		function FooterComponent() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, FooterComponent);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				show: true
			}, _this.handleToggleClick = function () {
				_this.setState({ show: !_this.state.show });
			}, _this.renderFooterBody = function () {
				var sections = _this.props.sections;
				return _react2.default.createElement(
					'div',
					{ className: _this.state.show ? _styles.innerWrapperStyleShown : _styles.innerWrapperStyleHidden },
					_react2.default.createElement(
						'div',
						{ className: _styles.mobileSocialIconsStyle },
						_react2.default.createElement(_socialIcons.SocialIcons, { mode: 'share', width: 18, inline: true, center: true })
					),
					_react2.default.createElement(
						'div',
						{ className: _styles.columnsStyle },
						_react2.default.createElement(
							'div',
							{ className: _styles.logoStyle },
							_react2.default.createElement('img', { src: _logo2.default, alt: 'Inside Out : Institute for Eating Disorders' }),
							_react2.default.createElement(_socialIcons.SocialIcons, { mode: 'share', width: 18, inline: true, center: true })
						),
						_react2.default.createElement(
							'div',
							{ className: _styles.sectionsStyle },
							sections && sections.map(function (section) {
								return _react2.default.createElement(
									'div',
									{ key: Math.random() * 99999 },
									_react2.default.createElement(
										'div',
										{ className: _styles.sectionTitleStyle },
										section.title
									),
									section.component
								);
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _styles.termsAndCopyrightWrapper },
						_react2.default.createElement(
							'div',
							{ className: _styles.termsAndCopyright },
							_react2.default.createElement(
								'nav',
								null,
								_react2.default.createElement(
									_link.Link,
									{ to: '/terms-and-conditions' },
									'Terms & Conditions'
								),
								_react2.default.createElement(
									_link.Link,
									{ to: '/privacy-policy' },
									'Privacy Policy'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'\xA9 ',
								new Date().getFullYear(),
								' InsideOut'
							)
						)
					)
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		FooterComponent.prototype.render = function render() {
			return _react2.default.createElement(
				'footer',
				{ className: _styles.wrapperStyle },
				_react2.default.createElement(
					'div',
					{ className: _styles.topSectionMobile },
					_react2.default.createElement(
						'div',
						{ className: _styles.menuIconStyle },
						_react2.default.createElement('img', {
							src: this.state.show ? _closeIcon2.default : _hamburgerIcon2.default,
							alt: 'TODO',
							onClick: this.handleToggleClick
						})
					)
				),
				this.renderFooterBody()
			);
		};
	
		return FooterComponent;
	}(_react2.default.PureComponent);
	
	FooterComponent.propTypes = {
		sections: _propTypes2.default.array
	};
	
	var Footer = exports.Footer = FooterComponent;

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(983);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.termsAndCopyright = exports.termsAndCopyrightWrapper = exports.sectionTitleStyle = exports.sectionsStyle = exports.topSectionMobile = exports.closeIconStyle = exports.menuIconStyle = exports.logoStyle = exports.columnsStyle = exports.innerWrapperStyleShown = exports.innerWrapperStyleHidden = exports.innerWrapperStyle = exports.mobileSocialIconsStyle = exports.wrapperStyle = undefined;
	
	var _css, _css2, _extends2, _css3, _css4, _css5, _css6;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)(_extends({}, _globalStyles.helvetica, {
		borderTop: '1px solid ' + _globalStyles.lightGrey
	}));
	
	var mobileSocialIconsStyle = /*#__PURE__*/exports.mobileSocialIconsStyle = (0, _emotion.css)((_css = {
		display: 'none'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'block',
		marginBottom: '30px',
		padding: '0 30px'
	}, _css));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)((_css2 = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '60px 20px'
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		padding: '20px 10px'
	}, _css2));
	
	var innerWrapperStyleHidden = /*#__PURE__*/exports.innerWrapperStyleHidden = (0, _emotion.css)(_extends({}, innerWrapperStyle, (_extends2 = {}, _extends2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _extends2)));
	
	var innerWrapperStyleShown = exports.innerWrapperStyleShown = innerWrapperStyle;
	
	var columnsStyle = /*#__PURE__*/exports.columnsStyle = (0, _emotion.css)({
		display: 'flex'
	});
	
	var logoStyle = /*#__PURE__*/exports.logoStyle = (0, _emotion.css)((_css3 = {
		padding: '0 20px 0 0',
		'& > img:first-child': {
			width: '158px',
			height: '54px',
			marginBottom: '30px'
		},
		'& [data-component=SocialIcons]': {
			padding: '0 10px'
		}
	}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css3));
	
	var menuIconStyle = /*#__PURE__*/exports.menuIconStyle = (0, _emotion.css)((_css4 = {
		'& img': {
			width: '20px',
			height: '20px',
			float: 'right',
			padding: '10px'
		}
	}, _css4['@media (min-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& img': {
			display: 'none'
		}
	}, _css4));
	
	var closeIconStyle = /*#__PURE__*/exports.closeIconStyle = (0, _emotion.css)((_css5 = {
		'& img': {
			width: '20px',
			height: '20px',
			float: 'right',
			padding: '10px'
		}
	}, _css5['@media (min-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& img': {
			display: 'none'
		}
	}, _css5));
	
	var topSectionMobile = /*#__PURE__*/exports.topSectionMobile = (0, _emotion.css)({
		width: '100%',
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint
	});
	
	var sectionsStyle = /*#__PURE__*/exports.sectionsStyle = (0, _emotion.css)({
		display: 'flex',
		flexWrap: 'wrap',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		alignContent: 'flex-start',
		margin: '-10px 0 0 0',
		'& > div': {
			padding: '10px',
			minWidth: '110px',
			'&:last-child': {
				paddingRight: 0
			}
		}
	});
	
	var sectionTitleStyle = exports.sectionTitleStyle = (0, _emotion.cx)(_globalStyles.label, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '17px'
	}));
	
	var termsAndCopyrightWrapper = /*#__PURE__*/exports.termsAndCopyrightWrapper = (0, _emotion.css)({
		borderTop: '1px solid ' + _globalStyles.lightGrey
	});
	
	var termsAndCopyright = /*#__PURE__*/exports.termsAndCopyright = (0, _emotion.css)((_css6 = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		display: 'table',
		padding: '15px 20px',
		'& nav': {
			display: 'table-cell',
			a: (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
				textDecoration: 'none',
				fontSize: '14px',
				lineHeight: '22px',
				'&:not(:last-child)': {
					marginRight: '40px',
					position: 'relative',
					'&:after': {
						content: "'•'",
						display: 'block',
						position: 'absolute',
						transform: 'translate(-50%, -50%)',
						left: 'calc(100% + 20px)',
						top: '50%'
					}
				}
			}))
		},
		'& p': {
			margin: '0',
			display: 'table-cell',
			textAlign: 'right',
			fontSize: '14px',
			lineHeight: '22px',
			color: '#8A8B8C'
		}
	}, _css6['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'block',
		'& nav, & p': {
			display: 'block',
			textAlign: 'left'
		},
		'& p': {
			marginTop: '15px'
		}
	}, _css6));

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GreyBar = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(9);
	
	var _styles = __webpack_require__(992);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GreyBar = exports.GreyBar = function GreyBar(_ref) {
		var links = _ref.links,
		    topMargin = _ref.topMargin;
		return _react2.default.createElement(
			'div',
			{ 'data-component': 'GreyBar', className: (0, _styles.wrapperStyle)(topMargin) },
			_react2.default.createElement(
				'nav',
				{ className: _styles.innerWrapperStyle },
				_react2.default.createElement(
					_link.Link,
					{ to: '/get-involved/make-a-donation' },
					'Want to help our cause? ',
					_react2.default.createElement(
						'button',
						{ className: _styles.donateButtonStyle },
						'Donate'
					)
				)
			)
		);
	};
	
	GreyBar.propTypes = {
		topMargin: _propTypes2.default.number.isRequired
	};

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(990);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.donateButtonStyle = exports.innerWrapperStyle = exports.wrapperStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(topMargin) {
		return (/*#__PURE__*/(0, _emotion.css)(_extends({}, _globalStyles.helvetica, {
				height: '32px',
				background: _globalStyles.lightGrey,
				position: 'sticky',
				top: 0 + topMargin + 'px',
				zIndex: 3
			}))
		);
	};
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		'& a': {
			lineHeight: '32px',
			color: _globalStyles.grey,
			fontSize: '12px',
			textDecoration: 'none',
			display: 'inline-block'
		}
	});
	
	var donateButtonStyle = /*#__PURE__*/exports.donateButtonStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
		background: _globalStyles.pink,
		border: 'none',
		color: '#fff',
		fontSize: '12px',
		lineHeight: '15px',
		letterSpacing: '0.5',
		borderRadius: '3px',
		textTransform: 'uppercase',
		padding: '5px 7px 1px 7px',
		marginLeft: '2px'
	}));

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Header = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactApollo = __webpack_require__(89);
	
	var _navManager = __webpack_require__(22);
	
	var _authManager = __webpack_require__(35);
	
	var _link = __webpack_require__(9);
	
	var _logo = __webpack_require__(431);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _logoMobile = __webpack_require__(765);
	
	var _logoMobile2 = _interopRequireDefault(_logoMobile);
	
	var _hamburgerIcon = __webpack_require__(868);
	
	var _hamburgerIcon2 = _interopRequireDefault(_hamburgerIcon);
	
	var _cogGreyIcon = __webpack_require__(3698);
	
	var _cogGreyIcon2 = _interopRequireDefault(_cogGreyIcon);
	
	var _bookmarkDropDownIcon = __webpack_require__(3690);
	
	var _bookmarkDropDownIcon2 = _interopRequireDefault(_bookmarkDropDownIcon);
	
	var _loggedInUser = __webpack_require__(2387);
	
	var LOGGED_IN_USER = _interopRequireWildcard(_loggedInUser);
	
	var _header = __webpack_require__(994);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = exports.Header = function (_React$PureComponent) {
		_inherits(Header, _React$PureComponent);
	
		function Header() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Header);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				isLoggedIn: _authManager.AuthManager.sharedInstance.isLoggedIn
			}, _this.loggedInDidChange = function () {
				_this.setState({ isLoggedIn: _authManager.AuthManager.sharedInstance.isLoggedIn });
			}, _this.renderRightCallToAction = function (_ref) {
				var loading = _ref.loading,
				    error = _ref.error,
				    data = _ref.data;
				var isLoggedIn = _this.state.isLoggedIn;
	
	
				if (isLoggedIn && loading) {
					return _react2.default.createElement(
						'span',
						{ id: 'header-right' },
						_react2.default.createElement(
							'p',
							null,
							'Loading...'
						)
					);
				}
	
				if (data && data.user) {
					var user = data.user;
	
					return _react2.default.createElement(
						'div',
						{ className: _header.myAccountDropDowWrapperStyle },
						_react2.default.createElement(
							_link.Link,
							{ to: '/my-account', tabIndex: '0' },
							user.avatar && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('img', { src: user.avatar, alt: 'Avatar' })
								)
							),
							_react2.default.createElement(
								'div',
								null,
								'My Account'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _header.myAccountDropDownStyle },
							_react2.default.createElement(
								_link.Link,
								{ to: '/my-bookmarks' },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement('img', { src: _bookmarkDropDownIcon2.default, alt: '' })
								),
								' ',
								'Bookmarks'
							),
							_react2.default.createElement(
								_link.Link,
								{ to: '/my-account' },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement('img', { src: _cogGreyIcon2.default, alt: '' })
								),
								' ',
								'Account Settings'
							),
							_react2.default.createElement(
								'a',
								{ onClick: _authManager.AuthManager.sharedInstance.logout },
								'Log out'
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'span',
						{ id: 'header-right' },
						_react2.default.createElement(
							_link.Link,
							{ to: '/log-in' },
							'Log in'
						),
						_react2.default.createElement(
							'button',
							{ className: _header.riskButtonStyle, onClick: function onClick() {
									return (0, _link.navigateTo)('/screener');
								} },
							'Are you at risk?'
						)
					);
				}
			}, _this.clearMenuFocus = function (e) {
				e.target.blur();
				console.log(e.currentTarget);
				e.currentTarget.style.pointerEvents = 'none';
				e.currentTarget.style.pointerEvents = 'auto';
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Header.prototype.componentWillMount = function componentWillMount() {
			_authManager.AuthManager.sharedInstance.subscribe(this.loggedInDidChange);
		};
	
		Header.prototype.componentWillUnmount = function componentWillUnmount() {
			_authManager.AuthManager.sharedInstance.unsubscribe(this.loggedInDidChange);
		};
	
		Header.prototype.render = function render() {
			var _this2 = this;
	
			var _props = this.props,
			    navLinks = _props.navLinks,
			    topMargin = _props.topMargin;
	
	
			return _react2.default.createElement(
				_reactApollo.Query,
				{ query: LOGGED_IN_USER },
				function (_ref2) {
					var loading = _ref2.loading,
					    error = _ref2.error,
					    data = _ref2.data;
	
	
					// If the client browser tries to login using the old cookie, log them out. 
					if (error) {
						_authManager.AuthManager.sharedInstance.logout();
					}
					return _react2.default.createElement(
						'div',
						{ 'data-component': 'Header', className: (0, _header.wrapperStyle)(topMargin) },
						_react2.default.createElement(
							'nav',
							{ className: _header.innerWrapperStyle },
							_react2.default.createElement(
								'span',
								{ className: _header.leftStyle },
								_react2.default.createElement(
									_link.Link,
									{ to: '/', className: _header.logoStyle },
									_react2.default.createElement('img', {
										id: 'logoDesktop',
										src: _logo2.default,
										alt: 'Inside Out : Institute for Eating Disorders'
									}),
									_react2.default.createElement('img', {
										id: 'logoMobile',
										src: _logoMobile2.default,
										alt: 'Inside Out : Institute for Eating Disorders'
									})
								),
								_react2.default.createElement(
									'nav',
									{ className: _header.headerLinksStyle },
									navLinks && navLinks.map(function (link, i) {
										return typeof link.to === 'string' && link.to !== '' ? _react2.default.createElement(
											_link.Link,
											{ className: (0, _header.headerLinkStyle)(46), key: i, to: link.to },
											link.text
										) : _react2.default.createElement(
											'div',
											{ className: _header.headerMenuLinkStyle, key: i, tabIndex: '0', 'aria-haspopup': 'true', onClick: _this2.clearMenuFocus },
											link.text,
											link.children && _react2.default.createElement(
												'div',
												{ className: _header.submenuStyle, 'aria-label': 'submenu' },
												link.children.map(function (sublink) {
													return _react2.default.createElement(
														_link.Link,
														{ className: (0, _header.headerLinkStyle)(40), key: sublink.to, to: sublink.to },
														sublink.text
													);
												})
											)
										);
									})
								)
							),
							_react2.default.createElement(
								'span',
								{ className: _header.rightStyle },
								_this2.renderRightCallToAction({ loading: loading, error: error, data: data }),
								_react2.default.createElement(
									'span',
									{ id: 'hamburger', onClick: _navManager.NavManager.showNavigation },
									_react2.default.createElement('img', { src: _hamburgerIcon2.default, alt: 'Navigation' })
								)
							)
						)
					);
				}
			);
		};
	
		return Header;
	}(_react2.default.PureComponent);
	
	Header.propTypes = {
		navLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			to: _propTypes2.default.string.isRequired,
			text: _propTypes2.default.string,
			submenu: _propTypes2.default.arrayOf(_propTypes2.default.shape({
				to: _propTypes2.default.string.isRequired,
				text: _propTypes2.default.string.isRequired
			}))
		})),
		topMargin: _propTypes2.default.number.isRequired
	};

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.myAccountDropDownStyle = exports.myAccountDropDowWrapperStyle = exports.riskButtonStyle = exports.rightStyle = exports.logoStyle = exports.headerMenuLinkStyle = exports.submenuStyle = exports.headerLinkStyle = exports.headerLinksStyle = exports.leftStyle = exports.innerWrapperStyle = exports.wrapperStyle = exports.errorStyle = undefined;
	
	var _css, _hoverFocus, _css2, _css3, _css4;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _dropDownGreyIcon = __webpack_require__(762);
	
	var _dropDownGreyIcon2 = _interopRequireDefault(_dropDownGreyIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorStyle = /*#__PURE__*/exports.errorStyle = (0, _emotion.css)({
		color: _globalStyles.pink,
		fontWeight: 'bold',
		textTransform: 'uppercase',
		fontSize: '12px'
	});
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(topMargin) {
		var _extends2;
	
		return (/*#__PURE__*/(0, _emotion.css)(_extends({}, _globalStyles.helvetica, (_extends2 = {
				position: 'sticky',
				top: 32 + topMargin + 'px',
				zIndex: 3,
				height: '70px',
				borderBottom: '1px solid ' + _globalStyles.lightGrey,
				background: '#fff'
	
			}, _extends2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
				top: topMargin + 'px'
			}, _extends2)))
		);
	};
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	});
	
	var leftStyle = /*#__PURE__*/exports.leftStyle = (0, _emotion.css)({
		display: 'flex',
		alignItems: 'center'
	});
	
	var headerLinksStyle = /*#__PURE__*/exports.headerLinksStyle = (0, _emotion.css)((_css = {
		paddingLeft: '39px',
		display: 'flex',
		alignItems: 'center'
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css));
	
	var headerLinkCommonStyle = function headerLinkCommonStyle(height, noMargin) {
		return (/*#__PURE__*/(0, _emotion.css)(_extends({
				height: height,
				display: 'flex',
				alignItems: 'center',
				fontWeight: 500,
				color: _globalStyles.grey,
				fontSize: '14px',
				textDecoration: 'none',
				cursor: 'pointer'
			}, !noMargin && {
				'&:not(:last-child)': {
					marginRight: '30px'
				}
			}))
		);
	};
	
	var headerLinkStyle = exports.headerLinkStyle = function headerLinkStyle(submenu) {
		return (0, _emotion.cx)(headerLinkCommonStyle(submenu ? 40 : 40, submenu), /*#__PURE__*/(0, _emotion.css)({
			'&:hover, &:focus, &:focus-within': {
				color: _globalStyles.darkGrey
			}
		}));
	};
	
	var submenuStyle = /*#__PURE__*/exports.submenuStyle = (0, _emotion.css)({
		visibility: 'hidden',
		opacity: 0,
		position: 'absolute',
		top: '100%',
		left: '0',
		transform: 'perspective(400) rotate3d(1,0,0,-45deg)',
		transformOrigin: '50% 0',
		transition: 'all 0.2s ease-in-out',
		padding: '8px 16px',
		minWidth: '230px',
		border: '1px solid ' + _globalStyles.lightGrey,
		borderRadius: '4px',
		background: '#FFFFFF',
		boxShadow: '0 6px 12px 0 rgba(32,33,39,0.08)'
	});
	
	var headerMenuLinkStyle = exports.headerMenuLinkStyle = (0, _emotion.cx)(headerLinkCommonStyle(46), /*#__PURE__*/(0, _emotion.css)({
		position: 'relative',
		'&:hover, &:focus, &:focus-within': (_hoverFocus = {
			outline: 'none',
			color: _globalStyles.darkGrey
		}, _hoverFocus['.' + submenuStyle] = {
			visibility: 'visible',
			opacity: 1,
			transform: 'perspective(400) rotate3d(0,0,0,0)'
		}, _hoverFocus),
		'&:after': {
			display: 'block',
			content: '" "',
			width: '8px',
			height: '6px',
			marginLeft: '8px',
			background: 'url(' + _dropDownGreyIcon2.default + ') no-repeat center bottom',
			backgroundSize: 'contain'
		}
	}));
	
	var logoStyle = /*#__PURE__*/exports.logoStyle = (0, _emotion.css)((_css2 = {
		display: 'table-cell',
		'& #logoDesktop': {
			width: '158px',
			height: '54px'
		},
		'& #logoMobile': {
			display: 'none',
			height: '36px'
		}
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& #logoDesktop': {
			display: 'none'
		},
		'& #logoMobile': {
			display: 'block'
		}
	}, _css2));
	
	var rightStyle = /*#__PURE__*/exports.rightStyle = (0, _emotion.css)((_css3 = {
		flexShrink: 0,
	
		'a': {
			color: _globalStyles.grey,
			fontSize: '14px',
			fontWeight: 500,
			textDecoration: 'none'
		},
		'& #hamburger': {
			display: 'none'
		}
	}, _css3['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		'& #header-right': {
			display: 'none'
		},
		'& #hamburger': {
			display: 'inline-block',
			width: '24px',
			height: '24px'
		}
	}, _css3));
	
	var riskButtonStyle = /*#__PURE__*/exports.riskButtonStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
		background: _globalStyles.aqua,
		border: 'none',
		color: '#fff',
		fontSize: '14px',
		letterSpacing: '0.58px',
		borderRadius: '4px',
		textTransform: 'uppercase',
		padding: '9px 11px 5px 11px',
		marginLeft: '24px'
	}));
	
	var myAccountDropDowWrapperStyle = /*#__PURE__*/exports.myAccountDropDowWrapperStyle = (0, _emotion.css)((_css4 = {
		position: 'relative',
		'& > a': {
			display: 'table',
			position: 'relative',
			paddingRight: '22px',
			'& > div': {
				display: 'table-cell',
				verticalAlign: 'middle',
	
				'&:first-child': {
					paddingRight: '10px',
					'& div': {
						width: '18px',
						height: '18px',
						position: 'relative',
						background: _globalStyles.blue,
						border: '2px solid ' + _globalStyles.lightGrey,
						borderRadius: '9px'
					}
				}
			},
			'&:after': {
				position: 'absolute',
				right: '0',
				top: '50%',
				transform: 'translateY(-50%)',
				content: '" "',
				display: 'block',
				width: '12px',
				height: '7px',
				background: 'url(' + _dropDownGreyIcon2.default + ') no-repeat center center'
			},
			'&:focus': {
				pointerEvents: 'none',
				'&  + div': {
					opacity: '1',
					visibility: 'visible',
					pointerEvents: 'auto'
				}
			}
		}
	}, _css4['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css4));
	
	var myAccountDropDownStyle = /*#__PURE__*/exports.myAccountDropDownStyle = (0, _emotion.css)({
		opacity: '0',
		visibility: 'hidden',
		transition: 'visibility 0.5s',
		position: 'absolute',
		top: '26px',
		background: '#fff',
		right: '0',
		boxShadow: 'rgba(0,0,0,0.20) 0 17px 24px 0',
		width: '230px',
		borderRadius: '4px',
		border: '1px solid ' + _globalStyles.lightGrey,
		'& a': {
			display: 'block',
			padding: '16px',
			color: _globalStyles.darkGrey,
			fontSize: '14px',
			lineHeight: '14px',
			verticalAlign: 'middle',
			'& span': {
				verticalAlign: 'middle',
				width: '20px',
				marginRight: '10px',
				display: 'inline-block'
			},
			'&:last-child': {
				position: 'relative',
				color: _globalStyles.grey,
				'&:after': {
					content: '" "',
					position: 'absolute',
					top: '0',
					left: '4%',
					width: '92%',
					height: '1px',
					background: _globalStyles.lightGrey,
					display: 'block'
				}
			}
		}
	});

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _header = __webpack_require__(993);
	
	Object.keys(_header).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _header[key];
	    }
	  });
	});

/***/ }),

/***/ 2387:
/***/ (function(module, exports) {

	
	    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HeaderFetchLoggedInUser"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"loggedInUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":null}]}}]}}],"loc":{"start":0,"end":83}};
	    doc.loc.source = {"body":"query HeaderFetchLoggedInUser {\n\tuser: loggedInUser {\n\t\tid\n\t\tfirstName\n\t\ttype\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
	  
	
	    var names = {};
	    function unique(defs) {
	      return defs.filter(
	        function(def) {
	          if (def.kind !== 'FragmentDefinition') return true;
	          var name = def.name.value
	          if (names[name]) {
	            return false;
	          } else {
	            names[name] = true;
	            return true;
	          }
	        }
	      )
	    }
	  
	
	    // Collect any fragment/type references from a node, adding them to the refs Set
	    function collectFragmentReferences(node, refs) {
	      if (node.kind === "FragmentSpread") {
	        refs.add(node.name.value);
	      } else if (node.kind === "VariableDefinition") {
	        var type = node.type;
	        if (type.kind === "NamedType") {
	          refs.add(type.name.value);
	        }
	      }
	
	      if (node.selectionSet) {
	        node.selectionSet.selections.forEach(function(selection) {
	          collectFragmentReferences(selection, refs);
	        });
	      }
	
	      if (node.variableDefinitions) {
	        node.variableDefinitions.forEach(function(def) {
	          collectFragmentReferences(def, refs);
	        });
	      }
	
	      if (node.definitions) {
	        node.definitions.forEach(function(def) {
	          collectFragmentReferences(def, refs);
	        });
	      }
	    }
	
	    var definitionRefs = {};
	    (function extractReferences() {
	      doc.definitions.forEach(function(def) {
	        if (def.name) {
	          var refs = new Set();
	          collectFragmentReferences(def, refs);
	          definitionRefs[def.name.value] = refs;
	        }
	      });
	    })();
	
	    function findOperation(doc, name) {
	      for (var i = 0; i < doc.definitions.length; i++) {
	        var element = doc.definitions[i];
	        if (element.name && element.name.value == name) {
	          return element;
	        }
	      }
	    }
	
	    function oneQuery(doc, operationName) {
	      // Copy the DocumentNode, but clear out the definitions
	      var newDoc = {
	        kind: doc.kind,
	        definitions: [findOperation(doc, operationName)]
	      };
	      if (doc.hasOwnProperty("loc")) {
	        newDoc.loc = doc.loc;
	      }
	
	      // Now, for the operation we're running, find any fragments referenced by
	      // it or the fragments it references
	      var opRefs = definitionRefs[operationName] || new Set();
	      var allRefs = new Set();
	      var newRefs = new Set();
	
	      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
	      opRefs.forEach(function(refName) {
	        newRefs.add(refName);
	      });
	
	      while (newRefs.size > 0) {
	        var prevRefs = newRefs;
	        newRefs = new Set();
	
	        prevRefs.forEach(function(refName) {
	          if (!allRefs.has(refName)) {
	            allRefs.add(refName);
	            var childRefs = definitionRefs[refName] || new Set();
	            childRefs.forEach(function(childRef) {
	              newRefs.add(childRef);
	            });
	          }
	        });
	      }
	
	      allRefs.forEach(function(refName) {
	        var op = findOperation(doc, refName);
	        if (op) {
	          newDoc.definitions.push(op);
	        }
	      });
	
	      return newDoc;
	    }
	
	    module.exports = doc;
	    
	        module.exports["HeaderFetchLoggedInUser"] = oneQuery(doc, "HeaderFetchLoggedInUser");
	        


/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LinkList = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(9);
	
	var _styles = __webpack_require__(1006);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkListComponent = function LinkListComponent(_ref) {
		var links = _ref.links;
		return (
			// TODO: nav / div switch
			_react2.default.createElement(
				'nav',
				{ className: _styles.wrapperStyle },
				(Array.isArray(links) ? links : [links]).map(function (link) {
					return _react2.default.createElement(
						_link.Link,
						{ key: link.to, to: link.to },
						link.text
					);
				})
			)
		);
	};
	
	LinkListComponent.propTypes = {
		links: _propTypes2.default.any
	};
	
	var LinkList = exports.LinkList = LinkListComponent;

/***/ }),

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(1004);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapperStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)(_extends({}, _globalStyles.helvetica, {
		'& a': {
			fontSize: '14px',
			textDecoration: 'none',
			display: 'block',
			lineHeight: '29px',
			color: _globalStyles.grey
		}
	}));

/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TopSticky = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(1024);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function colorify(str, defaultColor) {
	  if (str.length < 1) return defaultColor;
	  if (str.substr(0, 1) === '#') return '#' + str.substr(1, 6);else return '#' + str.substr(0, 6);
	}
	
	var TopSticky = exports.TopSticky = function (_React$PureComponent) {
	  _inherits(TopSticky, _React$PureComponent);
	
	  function TopSticky() {
	    _classCallCheck(this, TopSticky);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  TopSticky.prototype.render = function render() {
	    var _props = this.props,
	        content = _props.content,
	        color = _props.color,
	        bgColor = _props.bgColor,
	        onClose = _props.onClose;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _styles.wrapperStyle)(colorify(bgColor, '000000')) },
	      _react2.default.createElement('div', { className: _styles.bellIconStyle }),
	      _react2.default.createElement('div', { className: (0, _styles.contentStyle)(colorify(color, 'ffffff')), dangerouslySetInnerHTML: { __html: content } }),
	      _react2.default.createElement('div', { className: _styles.closeIconStyle, onClick: onClose })
	    );
	  };
	
	  return TopSticky;
	}(_react2.default.PureComponent);
	
	TopSticky.propTypes = {
	  content: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string,
	  bgColor: _propTypes2.default.string,
	  onClose: _propTypes2.default.func
	};

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(1022);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.closeIconStyle = exports.bellIconStyle = exports.contentStyle = exports.wrapperStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(bgColor) {
	  return (/*#__PURE__*/(0, _emotion.css)({
	      height: '56px',
	      width: '100%',
	      position: 'sticky',
	      top: '0',
	      backgroundColor: bgColor,
	      zIndex: 10,
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      padding: '10px'
	    })
	  );
	};
	
	var contentStyle = exports.contentStyle = function contentStyle(color) {
	  return (/*#__PURE__*/(0, _emotion.css)({
	      '&, & *': _extends({
	        color: color + ' !important'
	      }, _globalStyles.helvetica, {
	        fontSize: '16px',
	        lineHeight: '17px'
	      }),
	      '& a': {
	        fontWeight: '700'
	      }
	    })
	  );
	};
	
	var iconStyle = /*#__PURE__*/(0, _emotion.css)({
	  width: '24px',
	  height: '24px',
	  backgroundSize: 'content',
	  backgroundPosition: 'center',
	  backgroundRepeat: 'no-repeat'
	});
	
	var bellIconStyle = exports.bellIconStyle = (0, _emotion.cx)(iconStyle, /*#__PURE__*/(0, _emotion.css)({
	  marginRight: '8px',
	  backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMSI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0zLjEzMyAxMy4wOTRWNy4yNUMzLjEzMyA1LjEyNSA1LjggMyA5IDNzNS44NjcgMi4xMjUgNS44NjcgNC4yNXY1Ljg0NGMxLjQyMiAwIDIuMTMzLjcwOCAyLjEzMyAyLjEyNXMtLjcxMSAyLjEyNS0yLjEzMyAyLjEyNUgzLjEzM0MxLjcxMSAxNy4zNDQgMSAxNi42MzUgMSAxNS4yMTlzLjcxMS0yLjEyNSAyLjEzMy0yLjEyNXptMy43MzQgNC4yNWg0LjI2NmMwIDEuNzctLjcxIDIuNjU2LTIuMTMzIDIuNjU2cy0yLjEzMy0uODg1LTIuMTMzLTIuNjU2ek03LjUgM2MwLTEuMzMzLjUtMiAxLjUtMnMxLjUuNjY3IDEuNSAyaC0zeiIvPjwvc3ZnPg==")'
	}));
	
	var closeIconStyle = exports.closeIconStyle = (0, _emotion.cx)(iconStyle, /*#__PURE__*/(0, _emotion.css)({
	  position: 'absolute',
	  right: '16px',
	  top: '50%',
	  transform: 'translateY(-50%)',
	  mixBlendMode: 'difference',
	  cursor: 'pointer',
	  backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE4IiB3aWR0aD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTguOTg1IDcuNTcxbDYuMzY0LTYuMzY0YTEgMSAwIDAgMSAxLjQxNCAxLjQxNEwxMC40IDguOTg1bDYuMzY0IDYuMzY0YTEgMSAwIDAgMS0xLjQxNCAxLjQxNEw4Ljk4NSAxMC40bC02LjM2NCA2LjM2NGExIDEgMCAxIDEtMS40MTQtMS40MTRsNi4zNjQtNi4zNjQtNi4zNjQtNi4zNjRhMSAxIDAgMCAxIDEuNDE0LTEuNDE0eiIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+")'
	}));

/***/ }),

/***/ 3690:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMTYgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjIgKDUxMTYwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5SZWN0YW5nbGUgMTE0MzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjA0MTgyNzk2LDE2LjM2NTM2MjIgTDYuNTE1NTM1NzMsMTMuNTY5Mjk0OSBDNy4zOTg2Nzc1MSwxMy4wMTczMzEzIDguNjAxNDk1NSwxMy4wMTc0Mzk0IDkuNDg0NDY0MjcsMTMuNTY5Mjk0OSBMMTQsMTYuMzk2NDg0NCBMMTQsMi4wMDAwMTI3NyBMMi4wMDIxMjg4NSwyIEwyLjA0MTgyNzk2LDE2LjM2NTM2MjIgWiBNMi4wMDIxMjg4NSwwIEwxMy45OTc4NzExLDAgQzE1LjEwMzYxNjQsMCAxNiwwLjg5ODIxMjM4MSAxNiwyLjAwMDAxMjc3IEwxNiwxNy45OTk5ODcyIEMxNiwxOS4xMDQ1NjM4IDE1LjI0MDE2NzEsMTkuNTI1MTA0NCAxNC4zMDM0MDU4LDE4LjkzOTYyODYgTDguNDI0NDY2MzksMTUuMjY1MjkxNSBDOC4xOTAwNDAwNywxNS4xMTg3NzUgNy44MTAxMzY2OCwxNS4xMTg2NjQ2IDcuNTc1NTMzNjEsMTUuMjY1MjkxNSBMMS42OTY1OTQyNCwxOC45Mzk2Mjg2IEMwLjc1OTU5MTExNCwxOS41MjUyNTU2IDAsMTkuMTAxNzg3NiAwLDE3Ljk5OTk4NzIgTDAsMi4wMDAwMTI3NyBDMCwwLjg5NTQzNjIxNiAwLjg5NDUxMzc1NiwwIDIuMDAyMTI4ODUsMCBaIiBpZD0iUmVjdGFuZ2xlLTExNDMiIGZpbGw9IiM4QThCOEMiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxOCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHRpdGxlPmNsb3NlLW1lbnUtaWNvbjwvdGl0bGU+CjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgo8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjg5IC0xNDIzKSIgZmlsbD0iIzc1NzU3NSI+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTQwNCkiPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODYgMTcpIj4KPHJlY3QgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIgMTEuNykgcm90YXRlKDQ1KSB0cmFuc2xhdGUoLTEyIC0xMS43KSIgeT0iMTAuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjIuNCIgcng9IjEuMiIvPgo8cmVjdCB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMiAxMi4zKSByb3RhdGUoLTQ1KSB0cmFuc2xhdGUoLTEyIC0xMi4zKSIgeT0iMTEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjIuNCIgcng9IjEuMiIvPgo8L2c+CjwvZz4KPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 3698:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHRpdGxlPk1lbnU8L3RpdGxlPgo8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzA0IC0yNykiIGZpbGw9IiM3NTc1NzUiPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MDQgMjMpIj4KPHJlY3QgeT0iNC44IiB3aWR0aD0iMjQiIGhlaWdodD0iMi40IiByeD0iMS4yIi8+CjxyZWN0IHk9IjEwLjgiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyLjQiIHJ4PSIxLjIiLz4KPHJlY3QgeT0iMTYuOCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjIuNCIgcng9IjEuMiIvPgo8L2c+CjwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNiAzNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHRpdGxlPkluc2lkZSBPdXQgOiBJbnN0aXR1dGUgZm9yIEVhdGluZyBEaXNvcmRlcnMgTG9nbzwvdGl0bGU+CjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNSAtOSkiIGZpbGw9IiNGMDVCNUUiPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgNykiPgo8cGF0aCBkPSJtMjIuODQ5IDEyLjcyNmMtMC4wMDM2NjIyLTIuNzcxMy0xLjY4MTgtNC45MTk0LTQuMTUwMS01LjMxMjMtNC4xMTI2LTAuNjU0MzctNy4xNTg2IDIuNjUwOS02LjE4OTUgNi43MTQyIDAuNTkxODkgMi40ODE3IDIuMzA0OSA0LjEwMzMgNC40NjkyIDQuMjMwOCAzLjU0NjggMC4yMDkxOSA1Ljg3NTQtMi4wMjUxIDUuODcwNC01LjYzMjdtNy4zNzg3IDAuMDAyMTk3M2MtMC4wMDI3NDY2IDYuODkzNS01LjQzODcgMTIuMDU0LTEyLjY1NSAxMi4wMTUtNy4yMjI2LTAuMDM5OTkyLTEyLjU2Ny01LjEzMDgtMTIuNTczLTExLjk3Ny0wLjAwNjg2NjUtNi43ODcyIDUuMzEyNC0xMS43NTkgMTIuNTg5LTExLjc2NiA3LjI3NTctMC4wMDcwMzE1IDEyLjY0MSA0Ljk3MTcgMTIuNjM4IDExLjcyOSIvPgo8cGF0aCBkPSJtMTcuNzIgMzQuMzYyYy0xLjQ3NDUgMC0yLjk1IDAuMDI0NTg3LTQuNDIzMi0wLjAwNjc0MTYtMS41MjcyLTAuMDMyNTE4LTIuMTg5Ni0wLjYzMDE0LTIuMjY3Mi0xLjk1NjMtMC4xNzI2Mi0yLjk0NDEgMC4zMTkzNS0zLjM5MyAzLjcyMjctMy4zOTMgMi4zODE3IDMuOTY1ZS00IDQuNzYzOS0wLjAxOTAzNSA3LjE0NTYgMC4wMDk1MTc2IDIuMDY5NiAwLjAyNDE5IDIuNTg0OCAwLjUxMjM2IDIuNTkzNCAyLjMyODIgMC4wMTQwODIgMi43OTc0LTAuMjQ0MzkgMy4wMjE4LTMuNDgxOSAzLjAyMjItMS4wOTY2IDMuOTY1ZS00IC0yLjE5MjcgMC0zLjI4OTMgMHYtMC4wMDM5NjU3eiIvPgo8L2c+CjwvZz4KPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.8c297635.svg";

/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _topSticky = __webpack_require__(1023);
	
	var _greyBar = __webpack_require__(991);
	
	var _header = __webpack_require__(995);
	
	var _footer = __webpack_require__(984);
	
	var _linkList = __webpack_require__(1005);
	
	var _link = __webpack_require__(9);
	
	var _singleFieldForm = __webpack_require__(218);
	
	var _closeIcon = __webpack_require__(866);
	
	var _closeIcon2 = _interopRequireDefault(_closeIcon);
	
	var _navManager = __webpack_require__(22);
	
	var _authManager = __webpack_require__(35);
	
	var _formManager = __webpack_require__(106);
	
	var _main = __webpack_require__(1034);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainLayout = function (_React$PureComponent) {
		_inherits(MainLayout, _React$PureComponent);
	
		function MainLayout() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, MainLayout);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				navOpen: false,
				isLoggedIn: _authManager.AuthManager.sharedInstance.isLoggedIn,
				subscribeEmail: '',
				isTopStickyVisible: false
			}, _this.navOpenDidChange = function (navOpen) {
				if (navOpen) {
					document.documentElement.classList.add('noScroll');
				} else {
					document.documentElement.classList.remove('noScroll');
				}
				_this.setState({ navOpen: navOpen });
			}, _this.loggedInDidChange = function () {
				_this.setState({ isLoggedIn: _authManager.AuthManager.sharedInstance.isLoggedIn });
			}, _this.closeTopSticky = function () {
				if (typeof window === 'undefined') return;
				sessionStorage.setItem('top_sticky_closed', '1');
				_this.setState({ isTopStickyVisible: false });
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		MainLayout.prototype.componentWillMount = function componentWillMount() {
			_navManager.NavManager.subscribe(this.navOpenDidChange);
			_authManager.AuthManager.sharedInstance.subscribe(this.loggedInDidChange);
	
			if (typeof window !== 'undefined' && sessionStorage.getItem('top_sticky_closed') !== '1') {
				this.setState({ isTopStickyVisible: true });
			}
		};
	
		MainLayout.prototype.componentWillUnmount = function componentWillUnmount() {
			_navManager.NavManager.unsubscribe(this.navOpenDidChange);
			_authManager.AuthManager.sharedInstance.unsubscribe(this.loggedInDidChange);
		};
	
		MainLayout.prototype.render = function render() {
			var _this2 = this;
	
			var children = this.props.children;
	
			var pageSettings = this.props.data.page.edges[0].node;
			var top_sticky = pageSettings.top_sticky;
	
			var hasTopSticky = top_sticky && top_sticky.enabled && this.state.isTopStickyVisible;
			var topMargin = hasTopSticky ? 56 : 0;
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					'div',
					{ className: _main.wrapperStyle },
					_react2.default.createElement(_reactHelmet.Helmet, { titleTemplate: pageSettings.baseTitle + ' - %s' }),
					_react2.default.createElement(
						'a',
						{ href: '#content', className: _main.skipLinksStyle },
						'Skip links'
					),
					hasTopSticky && _react2.default.createElement(_topSticky.TopSticky, {
						bgColor: top_sticky.color,
						color: top_sticky.text_color,
						content: top_sticky.content,
						onClose: this.closeTopSticky
					}),
					_react2.default.createElement(_greyBar.GreyBar, { topMargin: topMargin }),
					_react2.default.createElement(_header.Header, {
						topMargin: topMargin,
						navLinks: pageSettings.header_links.map(function (link) {
							return {
								to: link.link_url,
								text: link.link_text,
								children: (link.submenu || []).map(function (sublink) {
									return {
										to: sublink.link_url,
										text: sublink.link_text
									};
								})
							};
						})
					}),
					_react2.default.createElement(
						'main',
						{ id: 'content' },
						children()
					),
					_react2.default.createElement(_footer.Footer, {
						sections: [].concat(pageSettings.footer_links.map(function (section) {
							return {
								title: section.section_name,
								component: _react2.default.createElement(_linkList.LinkList, {
									links: section.links.map(function (link) {
										return {
											to: link.link_url,
											text: link.link_text
										};
									})
								})
							};
						}), [{
							title: 'Newsletter',
							colspan: 2,
							component: _react2.default.createElement(_singleFieldForm.SingleFieldForm, {
								key: 'subscribe-form',
								inputId: 'subscribe-form',
								inputName: 'email',
								name: 'subscribe',
								netlify: true,
								placeholderText: 'email@example.com',
								label: 'Subscribe to our newsletter!',
								buttonContent: 'Subscribe',
								inputWidth: 181,
								onSubmit: function () {
									var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, value) {
										var result;
										return regeneratorRuntime.wrap(function _callee$(_context) {
											while (1) {
												switch (_context.prev = _context.next) {
													case 0:
														e.preventDefault();
														_context.prev = 1;
														_context.next = 4;
														return fetch('/', {
															method: 'POST',
															body: (0, _formManager.encode)({
																'form-name': 'subscribe',
																botField: '',
																email: value
															})
														});
	
													case 4:
														result = _context.sent;
	
	
														alert('Successfully signed up!');
														_context.next = 11;
														break;
	
													case 8:
														_context.prev = 8;
														_context.t0 = _context['catch'](1);
	
														console.error(_context.t0);
	
													case 11:
													case 'end':
														return _context.stop();
												}
											}
										}, _callee, _this2, [[1, 8]]);
									}));
	
									return function (_x, _x2) {
										return _ref.apply(this, arguments);
									};
								}()
							})
						}])
					})
				),
				this.state.navOpen && _react2.default.createElement('div', { className: _main.mobileNavOverlay, id: 'mobile-nav-overlay' }),
				this.state.navOpen && _react2.default.createElement(
					'div',
					{ className: _main.mobileNavStyle, id: 'mobile-nav' },
					_react2.default.createElement(
						'button',
						{ className: _main.closeIconStyle, onClick: _navManager.NavManager.hideNavigation },
						_react2.default.createElement('img', { src: _closeIcon2.default, alt: 'Close' })
					),
					pageSettings.mobile_links.map(function (section, index) {
						return _react2.default.createElement(
							'nav',
							{
								key: index,
								className: index % 2 ? _main.secondaryMobileNavStyle : _main.primaryMobileNavStyle
							},
							section.links.map(function (link, index) {
								return _react2.default.createElement(
									_link.Link,
									{ key: index, to: link.link_url, onClick: _navManager.NavManager.hideNavigation },
									link.link_text
								);
							})
						);
					}),
					_react2.default.createElement(
						'nav',
						null,
						this.state.isLoggedIn && _react2.default.createElement(
							_react2.default.Fragment,
							null,
							_react2.default.createElement(
								_link.Link,
								{ to: '/my-bookmarks', onClick: _navManager.NavManager.hideNavigation },
								'Bookmarks'
							),
							_react2.default.createElement(
								_link.Link,
								{ to: '/my-account', onClick: _navManager.NavManager.hideNavigation },
								'Account Settings'
							),
							_react2.default.createElement(
								_link.Link,
								{
									onClick: function onClick() {
										_navManager.NavManager.hideNavigation();
										_authManager.AuthManager.sharedInstance.logout();
									}
								},
								'Log Out'
							)
						),
						!this.state.isLoggedIn && _react2.default.createElement(
							_react2.default.Fragment,
							null,
							_react2.default.createElement(
								_link.Link,
								{ to: '/log-in', onClick: _navManager.NavManager.hideNavigation },
								'Log in'
							),
							_react2.default.createElement(
								_link.Link,
								{ to: '/register', onClick: _navManager.NavManager.hideNavigation },
								'Register'
							)
						)
					)
				)
			);
		};
	
		return MainLayout;
	}(_react2.default.PureComponent);
	
	MainLayout.propTypes = {
		children: _propTypes2.default.func.isRequired,
		data: _propTypes2.default.shape({
			allContentJson: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						baseTitle: _propTypes2.default.string,
						top_sticky: _propTypes2.default.shape({
							enabled: _propTypes2.default.bool.isRequired,
							color: _propTypes2.default.string,
							text_color: _propTypes2.default.string,
							content: _propTypes2.default.string
						}),
						header_links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							link_text: _propTypes2.default.string.isRequired,
							link_url: _propTypes2.default.string.isRequired
						})).isRequired,
						footer_links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							section_name: _propTypes2.default.string.isRequired,
							links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
								link_text: _propTypes2.default.string.isRequired,
								link_url: _propTypes2.default.string.isRequired
							})).isRequired
						})).isRequired,
						mobile_links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
								link_text: _propTypes2.default.string.isRequired,
								link_url: _propTypes2.default.string.isRequired
							})).isRequired
						})).isRequired
					})
				}))
			})
		})
	};
	exports.default = MainLayout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.mobileNavStyle = exports.secondaryMobileNavStyle = exports.primaryMobileNavStyle = exports.closeIconStyle = exports.mobileNavOverlay = exports.wrapperStyle = exports.skipLinksStyle = undefined;
	
	var _css;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var skipLinksStyle = /*#__PURE__*/exports.skipLinksStyle = (0, _emotion.css)({
		position: 'absolute',
		left: '-9999999px'
	});
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)((_css = {
		width: '100%'
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		'& [data-component=GreyBar]': {
			display: 'none'
		}
	}, _css));
	
	var mobileNavOverlay = /*#__PURE__*/exports.mobileNavOverlay = (0, _emotion.css)({
		//opacity: '0',
		position: 'fixed',
		zIndex: '2',
		top: '0',
		left: '0',
		width: '100%',
		height: '100%',
		background: 'rgba(0,0,0,0.7)',
		overflow: 'hidden'
	});
	
	var closeIconStyle = /*#__PURE__*/exports.closeIconStyle = (0, _emotion.css)({
		display: 'inline-block',
		width: '24px',
		height: '24px',
		position: 'absolute',
		top: '24px',
		right: '24px',
		padding: '0',
		border: '0'
	});
	
	var primaryMobileNavStyle = /*#__PURE__*/exports.primaryMobileNavStyle = (0, _emotion.css)({
		background: _globalStyles.lightGrey
	});
	
	var secondaryMobileNavStyle = /*#__PURE__*/exports.secondaryMobileNavStyle = (0, _emotion.css)({
		borderBottom: '1px solid ' + _globalStyles.lightGrey
	});
	
	var mobileNavStyle = /*#__PURE__*/exports.mobileNavStyle = (0, _emotion.css)({
		position: 'absolute',
		zIndex: '3',
		top: 0,
		//right: '100%',
		right: '0',
		width: '300px',
		height: '100%',
		background: '#fff',
		overflow: 'auto',
		'& nav': {
			padding: '24px',
			'& > a': {
				color: _globalStyles.grey,
				fontSize: '14px',
				lineHeight: '17px',
				display: 'block',
				margin: '24px 0',
				textDecoration: 'none',
				'&:first-child': {
					marginTop: 0
				},
				'&:last-child': {
					marginBottom: 0
				}
			},
			'&:first-of-type': {
				paddingTop: '75px'
			}
		}
	});

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-main-js-dc7e92abe19744a7700a.js